import { EmailGroupAction } from "../actions/types";

export default function reducer(state = {}, action) {
  switch (action.type) {
    case EmailGroupAction.FETCH_ALL_EMAIL_GROUPS:
      return { ...state, allEmailGroups: action.payload };
    case EmailGroupAction.FETCH_EMAIL_GROUPS:
      return { ...state, emailGroups: action.payload };
    case EmailGroupAction.FETCH_EMMAIL_GROUP_DETAIL:
      return { ...state, groupDetail: action.payload };
    default:
      return state;
  }
}
